import { createFileRoute } from "@tanstack/react-router";
import { catalogProviderAboutRoute } from "@/app-clients/catalog-detail/provider-route-data";
import { ProviderAboutPage } from "@/app-clients/catalog-detail/provider-subpages";

export const Route = createFileRoute("/provider/$providerId_/about")({
    ssr: catalogProviderAboutRoute.ssr,
    loader: catalogProviderAboutRoute.loader,
    head: catalogProviderAboutRoute.head,
    component: ProviderAboutPage,
});
